<template>
  <div id="interaction">
    <headerbom :hdtitle="'游戏SaaS'"></headerbom>
    <div class="banner">
      <img src="../img/interaction1.png" alt="">
    </div>
    <div class="h1_title">
      <h1>热门游戏多元 增加用户活跃</h1>
    </div>
    <div class="game_list">
      <van-swipe class="my-swipe" :autoplay="3000" indicator-color="white">
        <van-swipe-item v-for="(ele,index) in swiperlist" :key="index">
          <div class="game_cont">
            <section :class="{no_left: ky % 3 == 0}" @click="togame(val.alink)" v-for="(val,ky) in ele" :key="ky">
              <img :src="val.img" alt="">
              <span>{{val.name}}</span>
            </section>
          </div>
        </van-swipe-item>
      </van-swipe>
    </div>
    <div class="adkaps">
      <div class="h2_title">
        <h1>流量场景多元 优秀入口展示</h1>
      </div>
      <van-swipe class="adk_swiper" :loop="false" :autoplay="3000" :width="windowWith">
        <van-swipe-item v-for="(ele,index) in adlist" :key="index">
          <div class="adkaps_cont">
            <img :src="ele.img" alt="">
            <span>{{ele.name}}</span>
          </div>
        </van-swipe-item>
      </van-swipe>
    </div>
    <div class="h1_title">
      <h1>多种广告样式 丰富合作空间</h1>
    </div>
    <div class="adlist">
      <div class="adlist_box">
        <div class="adname">
          <div :class="{active_div: adnameindex == index}" v-for="(ele,index) in adnamelist" :key="index" @click="adnameindex = index">{{ele}}</div>
        </div>
        <div class="adiphone" v-for="(ele,index) in adnamecontlist" :key="index" v-show="adnameindex == index">
          <img :src="ele.img" alt="">
          <div class="right">
            <h1>{{ele.name}}</h1>
            <section>
              <p>产品说明</p>
              <span>{{ele.explain}}</span>
            </section>
            <section>
              <p>展现场景</p>
              <span>{{ele.scene}}</span>
            </section>
            <section>
              <p>优势</p>
              <span>{{ele.advantage}}</span>
            </section>
            <section>
              <p>常用尺寸</p>
              <span>{{ele.size}}</span>
            </section>
          </div>
        </div>
      </div>
    </div>
    <div class="call_me">
      <span>是否对我们的产品感兴趣了呢？</span>
      <h1>如果您对我们的产品非常感兴趣，</br>但还存在一点疑惑！</h1>
      <div @click="show = true">联系我们</div>
    </div>
    <van-dialog v-model="show" title="联系我们" show-cancel-button>
      <img src="../img/cpm.png" class="erweima" />
    </van-dialog>
    <footerbom></footerbom>
  </div>
</template>

<script type="text/javascript">
export default {
  data() {
    return {
      show: false,
      swiperlist: [
        [
          {
            alink:
              "https://res.12317wan.com/gameModule/h5/ddz/zdlcH5/package/150440/index.html",
            img: require("../img/gl1.png"),
            name: "天天斗地主（真人版）",
          },
          {
            alink:
              "https://fkdwy.res.jianshuwang.com.cn/fkdwy_adjuz/index.html",
            img: require("../img/gl2.png"),
            name: "疯狂动物雨",
          },
          {
            alink: "https://juzhangcdn.hongshunet.com/sandball/index.html",
            img: require("../img/gl3.png"),
            name: "装个球球",
          },
          {
            alink:
              "http://static.game.adjuz.net/game/static/html/zhiwudazhanjiangshi/",
            img: require("../img/gl4.png"),
            name: "植物打僵尸",
          },
          {
            alink:
              "https://gamesres.ultralisk.cn/h5_games_res/game75/juzhang/v0/",
            img: require("../img/gl5.png"),
            name: "小花仙守护天使 ",
          },
          {
            alink:
              "https://static.adjuz.net/game/static/html/taochugongsi/index.html",
            img: require("../img/gl6.png"),
            name: "逃出公司大作战",
          },
        ],
        [
          {
            alink: "https://thcq-jz.myworld6.com/web/index.html",
            img: require("../img/gl7.png"),
            name: "土豪传奇",
          },
          {
            alink:
              "https://bazfile.palmfungames.com/qgames/CZDTS/CZDTSjzzs/web-mobile/index.html",
            img: require("../img/gl8.png"),
            name: "锤子大逃杀",
          },
          {
            alink:
              "https://static.adjuz.com/game/static/html/juezhan/indexJuzhang.html",
            img: require("../img/gl9.png"),
            name: "决战战场",
          },
          {
            alink:
              "http://static.game.adjuz.net/game/static/html/longxingtanchishe",
            img: require("../img/gl10.png"),
            name: "龙形贪吃蛇",
          },
          {
            alink: "https://ldtgs2.yeyou365.com:8020/",
            img: require("../img/gl11.png"),
            name: "末日特工",
          },
          {
            alink: "https://static.kdyx.cn/sxkjuzhang/1001/index.html",
            img: require("../img/gl12.png"),
            name: "史小坑的爆笑生活",
          },
        ],
      ],
      adlist: [
        {
          img: require("../img/liu1.png"),
          name: "banner位置",
        },
        {
          img: require("../img/liu2.png"),
          name: "icon位置",
        },
        {
          img: require("../img/liu3.png"),
          name: "TAP位置",
        },
        {
          img: require("../img/liu4.png"),
          name: "菜单栏",
        },
        {
          img: require("../img/liu5.png"),
          name: "挂件",
        },
        {
          img: require("../img/liu6.png"),
          name: "开屏",
        },
        {
          img: require("../img/liu7.png"),
          name: "任务栏",
        },
      ],
      windowWith: 0,
      adnamelist: [
        "开屏广告",
        "banner广告",
        "贴片广告",
        "激励广告",
        "信息流广告",
      ],
      adnameindex: 0,
      adnamecontlist: [
        {
          img: require("../img/adiphone1.png"),
          name: "开屏广告",
          explain: "游戏中心开启时全屏展示的广告形式",
          scene: "游戏中心开启时，游戏开启时",
          advantage:
            "视觉效果震撼，提升媒体品牌价值，广告点击率高，变现能力出色 ",
          size: "1080x1920、768x1024、640x960、480x800",
        },
        {
          img: require("../img/adiphone2.png"),
          name: "banner广告",
          explain: "常用于小游戏页面固定位置，小游戏暂停页面的广告形式",
          scene: "常用于小游戏页面固定位置，小游戏暂停页面",
          advantage: "常规广告形式，通用性强。更适合非信息流场景需求",
          size: "370x254、640x90",
        },
        {
          img: require("../img/adiphone3.png"),
          name: "贴片广告",
          explain: "常用于小游戏结束场景，小游戏暂停场景的广告形式",
          scene: "常用于小游戏结束位置，小游戏暂停页面",
          advantage: "与小游戏内容结合高曝光率，增加提升广告流量",
          size: "1140x640",
        },
        {
          img: require("../img/adiphone4.png"),
          name: "激励广告",
          explain:
            "适用于小游戏激励场景引导用户观看页面广告，并达成奖励下发标准，用户可获得相应奖励。广告触发场景和奖励内容由媒体自定义",
          scene: "小游戏中解锁新关卡、游戏复活、获取通关提示、获取道具或积分等",
          advantage:
            "与奖励内容结合高曝光率，广告内容变现水平高，有助于提升小游戏变现能力",
          size: "全屏展示，比例9:16、16:9",
        },
        {
          img: require("../img/adiphone5.png"),
          name: "信息流广告",
          explain: "作为游戏中心内容的一部分与游戏内容高度融合的广告样式",
          scene: "游戏中心内容列表页展现的场景",
          advantage:
            "广告内容融入小游戏环境、深受优质小游戏青睐、有助于提升变现能力",
          size: "100x100、640x300",
        },
      ],
    };
  },
  computed: {},
  components: {},
  created() {},
  destroyed() {},
  mounted() {
    var clientWidth =
      window.innerWidth ||
      doc.documentElement.clientWidth ||
      doc.body.clientWidth;
    this.windowWith = clientWidth / 2;
  },
  methods: {
    togame(a) {
      window.open(a);
    },
  },
};
</script>

<style lang="less" scoped>
#interaction {
  box-sizing: border-box;
  padding-top: 1rem;
  .banner {
    img {
      width: 100%;
      height: auto;
    }
  }
  .h1_title {
    width: 100%;
    text-align: center;
    margin: 1rem 0 0.6rem;
    h1 {
      font-weight: 600;
      font-size: 0.36rem;
      color: #333;
      text-align: center;
      position: relative;
      letter-spacing: 0.04rem;
      &::after {
        position: absolute;
        content: "";
        width: 0.7rem;
        height: 0.04rem;
        background: @color;
        bottom: -0.16rem;
        left: 50%;
        transform: translateX(-50%);
      }
    }
  }
  .game_list {
    width: 100%;
    padding-bottom: 0.8rem;
    .my-swipe {
      width: 100%;
      .game_cont {
        width: 100%;
        display: flex;
        flex-wrap: wrap;
        padding: 0.1rem 0.22rem;
        box-sizing: border-box;
        section {
          width: 31%;
          overflow: hidden;
          margin-left: 3.5%;
          border-radius: 0.14rem;
          box-shadow: 0 0 0.12rem 0.02rem rgba(194, 218, 252, 0.7);
          box-sizing: border-box;
          padding: 1.4rem 0.28rem 0.26rem;
          position: relative;
          margin-bottom: 0.6rem;
          &.no_left {
            margin-left: 0;
          }
          img {
            width: 1rem;
            height: auto;
            border-radius: 0.1rem;
            position: absolute;
            left: 50%;
            top: 0.26rem;
            transform: translateX(-50%);
            z-index: 2;
          }
          span {
            text-align: center;
            display: block;
            overflow: hidden;
            white-space: nowrap;
            text-overflow: ellipsis;
            font-size: 0.28rem;
            color: #333;
          }
        }
      }
    }
  }
  .adkaps {
    width: 100%;
    height: 8.2rem;
    overflow: hidden;
    .h2_title {
      width: 100%;
      text-align: center;
      margin: 0.6rem 0 0.6rem;
      h1 {
        font-weight: 600;
        font-size: 0.36rem;
        color: #fff;
        text-align: center;
        position: relative;
        letter-spacing: 0.04rem;
        &::after {
          position: absolute;
          content: "";
          width: 0.7rem;
          height: 0.04rem;
          background: #fff;
          bottom: -0.16rem;
          left: 50%;
          transform: translateX(-50%);
        }
      }
    }
    background: url("../img/interaction2.png") no-repeat center center;
    background-size: cover;
    .adk_swiper {
      width: 100%;
      .adkaps_cont {
        width: 100%;
        padding: 0.1rem 0 0.3rem;
        img {
          width: 2.3rem;
          height: auto;
          border-radius: 0.3rem;
          margin: 0 auto;
        }
        span {
          display: block;
          color: #fff;
          text-align: center;
          width: 2.8rem;
          height: 0.8rem;
          background: url("../img/iphone_logo.png") no-repeat center center;
          background-size: cover;
          line-height: 0.8rem;
          margin: 0.38rem auto 0;
        }
      }
    }
  }
  .adlist {
    width: 100%;
    .adlist_box {
      width: 100%;
      margin-top: 0.7rem;
      margin-bottom: 0.7rem;
      .adname {
        display: flex;
        justify-content: space-around;
        box-sizing: border-box;
        padding: 0 0.22rem;
        div {
          width: 20%;
          text-align: center;
          color: #666;
          font-size: 0.2rem;
          cursor: pointer;
          border-radius: 0.2rem;
          padding: 0.07rem 0 0.09rem;
          &.active_div {
            color: #fff;
            background: @color;
            box-shadow: 0 0 0.12rem 0 rgba(0, 0, 0, 0.3);
          }
        }
      }
      .adiphone {
        margin-top: 0.56rem;
        box-sizing: border-box;
        padding: 0 0.22rem;
        overflow: hidden;
        img {
          width: 2.3rem;
          height: auto;
          border-radius: 0.38rem;
          margin-right: 0.2rem;
          flex-shrink: 0;
          float: left;
        }
        .right {
          display: flex;
          flex-direction: column;
          justify-content: center;
          float: right;
          width: 4.4rem;
          h1 {
            font-size: 0.32rem;
            color: #333;
            position: relative;
            box-sizing: border-box;
            margin-bottom: 0.4rem;
            &::after {
              content: "";
              display: block;
              width: 0.3rem;
              height: 0.04rem;
              border-radius: 0.04rem;
              bottom: -0.2rem;
              left: 0;
              background: @color;
              position: absolute;
            }
          }
          section {
            display: flex;
            overflow: hidden;
            margin-bottom: 0.2rem;
            p {
              font-size: 0.12rem;
              color: #333;
              width: 1rem;
              text-align: right;
              margin-right: 0.2rem;
              flex-shrink: 0;
              line-height: 0.36rem;
            }
            span {
              font-size: 0.12rem;
              color: #666;
              line-height: 0.36rem;
            }
          }
        }
      }
    }
  }
  .call_me {
    width: 100%;
    display: flex;
    flex-direction: column;
    justify-content: center;
    text-align: center;
    align-items: center;
    p {
      font-size: 0.24rem;
      color: @p;
    }
    h1 {
      font-size: 0.48rem;
      color: @h1;
      font-weight: bold;
      margin: 0.4rem 0;
      line-height: 0.7rem;
    }
    div {
      background: @color;
      color: #fff;
      font-size: 0.24rem;
      width: 2.96rem;
      text-align: center;
      line-height: 0.6rem;
      border-radius: 0.3rem;
      margin-bottom: 1rem;
    }
  }
  .erweima {
    width: 2rem;
    margin: 0.4rem auto;
  }
}
</style>
<style lang="less">
</style>



// WEBPACK FOOTER //
// src/page/interaction/index.vue